"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = __importDefault(require("."));
const Address_form_1 = __importDefault(require("./address/Address.form"));
const Button_form_1 = __importDefault(require("./button/Button.form"));
const Checkbox_form_1 = __importDefault(require("./checkbox/Checkbox.form"));
const Columns_form_1 = __importDefault(require("./columns/Columns.form"));
const Component_form_1 = __importDefault(require("./_classes/component/Component.form"));
const Container_form_1 = __importDefault(require("./container/Container.form"));
const Content_form_1 = __importDefault(require("./content/Content.form"));
const Currency_form_1 = __importDefault(require("./currency/Currency.form"));
const DataGrid_form_1 = __importDefault(require("./datagrid/DataGrid.form"));
const DataMap_form_1 = __importDefault(require("./datamap/DataMap.form"));
const DateTime_form_1 = __importDefault(require("./datetime/DateTime.form"));
const Day_form_1 = __importDefault(require("./day/Day.form"));
const EditGrid_form_1 = __importDefault(require("./editgrid/EditGrid.form"));
const Email_form_1 = __importDefault(require("./email/Email.form"));
const Fieldset_form_1 = __importDefault(require("./fieldset/Fieldset.form"));
const File_form_1 = __importDefault(require("./file/File.form"));
const Form_form_1 = __importDefault(require("./form/Form.form"));
const ListComponent_form_1 = __importDefault(require("./_classes/list/ListComponent.form"));
const Hidden_form_1 = __importDefault(require("./hidden/Hidden.form"));
const HTML_form_1 = __importDefault(require("./html/HTML.form"));
const NestedComponent_form_1 = __importDefault(require("./_classes/nested/NestedComponent.form"));
const Number_form_1 = __importDefault(require("./number/Number.form"));
const Panel_form_1 = __importDefault(require("./panel/Panel.form"));
const Password_form_1 = __importDefault(require("./password/Password.form"));
const PhoneNumber_form_1 = __importDefault(require("./phonenumber/PhoneNumber.form"));
const Radio_form_1 = __importDefault(require("./radio/Radio.form"));
const ReCaptcha_form_1 = __importDefault(require("./recaptcha/ReCaptcha.form"));
const SelectBoxes_form_1 = __importDefault(require("./selectboxes/SelectBoxes.form"));
const Select_form_1 = __importDefault(require("./select/Select.form"));
const Signature_form_1 = __importDefault(require("./signature/Signature.form"));
const Survey_form_1 = __importDefault(require("./survey/Survey.form"));
const Table_form_1 = __importDefault(require("./table/Table.form"));
const Tabs_form_1 = __importDefault(require("./tabs/Tabs.form"));
const Tags_form_1 = __importDefault(require("./tags/Tags.form"));
const TextArea_form_1 = __importDefault(require("./textarea/TextArea.form"));
const TextField_form_1 = __importDefault(require("./textfield/TextField.form"));
const Time_form_1 = __importDefault(require("./time/Time.form"));
const Unknown_form_1 = __importDefault(require("./unknown/Unknown.form"));
const Url_form_1 = __importDefault(require("./url/Url.form"));
const Well_form_1 = __importDefault(require("./well/Well.form"));
_1.default.address.editForm = Address_form_1.default;
_1.default.button.editForm = Button_form_1.default;
_1.default.checkbox.editForm = Checkbox_form_1.default;
_1.default.columns.editForm = Columns_form_1.default;
_1.default.component.editForm = Component_form_1.default;
_1.default.container.editForm = Container_form_1.default;
_1.default.content.editForm = Content_form_1.default;
_1.default.currency.editForm = Currency_form_1.default;
_1.default.datagrid.editForm = DataGrid_form_1.default;
_1.default.datamap.editForm = DataMap_form_1.default;
_1.default.datetime.editForm = DateTime_form_1.default;
_1.default.day.editForm = Day_form_1.default;
_1.default.editgrid.editForm = EditGrid_form_1.default;
_1.default.email.editForm = Email_form_1.default;
_1.default.fieldset.editForm = Fieldset_form_1.default;
_1.default.file.editForm = File_form_1.default;
_1.default.form.editForm = Form_form_1.default;
_1.default.list.editForm = ListComponent_form_1.default;
_1.default.hidden.editForm = Hidden_form_1.default;
_1.default.htmlelement.editForm = HTML_form_1.default;
_1.default.nested.editForm = NestedComponent_form_1.default;
_1.default.number.editForm = Number_form_1.default;
_1.default.panel.editForm = Panel_form_1.default;
_1.default.password.editForm = Password_form_1.default;
_1.default.phoneNumber.editForm = PhoneNumber_form_1.default;
_1.default.radio.editForm = Radio_form_1.default;
_1.default.recaptcha.editForm = ReCaptcha_form_1.default;
_1.default.select.editForm = Select_form_1.default;
_1.default.selectboxes.editForm = SelectBoxes_form_1.default;
_1.default.signature.editForm = Signature_form_1.default;
_1.default.survey.editForm = Survey_form_1.default;
_1.default.table.editForm = Table_form_1.default;
_1.default.tabs.editForm = Tabs_form_1.default;
_1.default.tags.editForm = Tags_form_1.default;
_1.default.textarea.editForm = TextArea_form_1.default;
_1.default.textfield.editForm = TextField_form_1.default;
_1.default.time.editForm = Time_form_1.default;
_1.default.unknown.editForm = Unknown_form_1.default;
_1.default.url.editForm = Url_form_1.default;
_1.default.well.editForm = Well_form_1.default;
exports.default = _1.default;
